import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
    :host {
        display: flex;
        flex-flow: column;
        gap: ${csSpacing.spacing05};
    }
`
